/**
 * ScheduleEvent Entity
 * Represents a scheduled event in the dashboard calendar
 */
export interface ScheduleEventProps {
  id: string;
  title: string;
  time: string;
  color: string;
}

export class ScheduleEvent {
  private readonly props: ScheduleEventProps;

  constructor(props: ScheduleEventProps) {
    this.props = props;
  }

  get id(): string {
    return this.props.id;
  }

  get title(): string {
    return this.props.title;
  }

  get time(): string {
    return this.props.time;
  }

  get color(): string {
    return this.props.color;
  }

  toPlainObject(): ScheduleEventProps {
    return { ...this.props };
  }
}
